// import logo from './logo.svg';
import Header from './component/Header';
import Cal from './component/Cal';
// import Footer from './component/Footer';

function App() {
  return (
    <div className="bg-brand">
      <Header />
      <Cal />
      {/* <Footer /> */}
    </div>
  );
}

export default App;
